import { MessageState } from 'support/types';

export const LINE_ITEMS_BIG_MESSAGE_THRESHOLD = 1000;

export const isBigMessage = (data: Record<string, unknown> | undefined): boolean => {
  const lineItems = data?.line_items as Array<unknown> | undefined;
  return (lineItems?.length ?? 0) > LINE_ITEMS_BIG_MESSAGE_THRESHOLD;
};

/**
 * Message states categorized by processing phase.
 * These help understand where a message is in its lifecycle.
 */

export const PROCESSING_MESSAGE_STATES = [
  MessageState.initial,
  MessageState.canonicalized,
  MessageState.enriched,
  MessageState.routed,
  MessageState.validated_for_destination,
] as const;

export const TERMINAL_MESSAGE_STATES = [
  MessageState.decanonicalized,
  MessageState.superseded,
  MessageState.post_processed,
  MessageState.pendingReview,
  MessageState.pendingCollection,
  MessageState.dropped,
] as const;

export const FAILED_MESSAGE_STATES = [
  MessageState.decanonicalizedFailed,
  MessageState.enrichedFailed,
  MessageState.routingFailed,
  MessageState.validation_for_destination_failed,
  MessageState.postProcessingFailed,
] as const;

export const isMessageBEValidationComplete = (internalState: string | undefined): boolean => {
  if (!internalState) {
    return false;
  }
  return (
    (TERMINAL_MESSAGE_STATES as ReadonlyArray<string>).includes(internalState) ||
    (FAILED_MESSAGE_STATES as ReadonlyArray<string>).includes(internalState)
  );
};
